import { render, staticRenderFns } from "./VRadioPreview.vue?vue&type=template&id=56615cbc&"
import script from "./VRadioPreview.vue?vue&type=script&lang=js&"
export * from "./VRadioPreview.vue?vue&type=script&lang=js&"
import style0 from "./VRadioPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports